import React, { useState , useRef, useEffect} from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaRegCalendarAlt, FaRegUser, FaHotel, FaFolderMinus,
  FaWhmcs, FaWalking, FaMoneyCheck, FaProjectDiagram,
  FaUserCircle, FaChevronDown,
  FaMoneyCheckAlt,
  FaCloudMoon,
  FaBusinessTime,
  FaUserSlash,
  FaRegClock,
  FaClock,
  FaCalendarMinus,
  FaLayerGroup,
  FaFileExport,
  FaShieldAlt,
  FaUsersCog,
  FaFileInvoice,
  FaHistory,
  FaPlusCircle,
  FaBolt,
  FaLock,
  FaCreditCard,
  FaBullhorn
} from "react-icons/fa";
import { MdBusiness } from "react-icons/md";
import { CiTimer } from "react-icons/ci";
import { useAuth } from "../navigation/AuthProvider";
import { logout_web_request } from "../utils/authRequests";
import { getPermission } from "../permissions/rolePermissions";
import "./css/nav.css";
import { ROLE_LABELS_SV } from "../permissions/roleLabels";
import { useHistoryAccess } from "../utils/useHistoryAccess";

export const Nav = () => {
  const location = useLocation();
  const { user, company, setLoading } = useAuth();
  const role = user?.role;
  const historyAccess = useHistoryAccess();



  const [profileMenuOpen, setProfileMenuOpen] = useState(false);

  const [projectMenuOpen, setProjectMenuOpen] = useState(
    localStorage.getItem("projectMenuOpen") === "true"
  );
  const [casesMenuOpen, setCasesMenuOpen] = useState(
    localStorage.getItem("casesMenuOpen") === "true"
  );
  const [payrollMenuOpen, setPayrollMenuOpen] = useState(
    localStorage.getItem("payrollMenuOpen") === "true"
  );
  const [timesmartMenuOpen, setTimesmartMenuOpen] = useState(
    localStorage.getItem("timesmartMenuOpen") === "true"
  );
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(
    localStorage.getItem("settingsMenuOpen") === "true"
  );

  const scrollRef = useRef(null);


  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleScroll = () => {
      localStorage.setItem("navScroll", String(el.scrollTop));
    };

    el.addEventListener("scroll", handleScroll);

    return () => el.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const saved = localStorage.getItem("navScroll");
    if (saved) {
      el.scrollTop = Number(saved);
    }
  }, []);

  const isActive = (path) => location.pathname === path;

  const toggleProjectMenu = () => {
    const next = !projectMenuOpen;
    setProjectMenuOpen(next);
    localStorage.setItem("projectMenuOpen", String(next));
  };

  const toggleCasesMenu = () => {
    const next = !casesMenuOpen;
    setCasesMenuOpen(next);
    localStorage.setItem("casesMenuOpen", String(next));
  };

  const togglePayrollMenu = () => {
    const next = !payrollMenuOpen;
    setPayrollMenuOpen(next);
    localStorage.setItem("payrollMenuOpen", String(next));
  };

  const toggleTimesmartMenu = () => {
    const next = !timesmartMenuOpen;
    setTimesmartMenuOpen(next);
    localStorage.setItem("timesmartMenuOpen", String(next));
  };

  const toggleSettingsMenu = () => {
    const next = !settingsMenuOpen;
    setSettingsMenuOpen(next);
    localStorage.setItem("settingsMenuOpen", String(next));
  };

  const handleLogoutClicked = async () => {
    setLoading(true);
    await logout_web_request();
    setLoading(false);
    window.location.href = "/";
  };

  const getTrialStatus = (date) => {
    const now = new Date();
    const end = new Date(date);

    const diffTime = end - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays <= 0) {
      return { status: "expired", days: 0 };
    }

    if (diffDays <= 3) {
      return { status: "urgent", days: diffDays };
    }

    if (diffDays <= 7) {
      return { status: "warning", days: diffDays };
    }

    return { status: "active", days: diffDays };
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2><CiTimer style={{ marginRight: "10px" }} />𝙏𝙞𝙢𝐞𝙎𝙢𝙖𝙧t</h2>
      </div>

      <div
        ref={scrollRef}
        className="sidebar-scroll"
        style={{ flex: 1, minHeight: 0, overflowY: "auto", paddingBottom: company?.trial?.isTrial ? 140 : 70 }}
      >
        <nav className="menu-links">

          {getPermission(role, "schedule") !== "none" && (
            <Link to="/shifts" className={`menu-link ${isActive("/shifts") ? "active" : ""}`}>
              <FaRegCalendarAlt style={{ marginRight: "10px" }} />
              Tidsschema
            </Link>
          )}

          {getPermission(role, "employees") !== "none" && (
            <Link to="/employees" className={`menu-link ${isActive("/employees") ? "active" : ""}`}>
              <FaRegUser style={{ marginRight: "10px" }} />
              Användare
            </Link>
          )}
          

          {getPermission(role, "cases") !== "none" && (
            <div className="settings-menu">
              <button onClick={toggleCasesMenu} className="menu-link settings-menu-button">
                <div>
                  <FaRegClock style={{ marginRight: "10px" }} />
                  Ärenden
                </div>
                <span className={`arrow ${casesMenuOpen ? "open" : ""}`}>▼</span>
              </button>
              {casesMenuOpen && (
                <div className="settings-submenu">
                  {getPermission(role, "cases:overtime") !== "none" && (
                    <Link to="/overtime-requests" className={`small-menu-link ${isActive("/overtime-requests") ? "active" : ""}`}>
                      <FaClock style={{ marginRight: "10px" }} />
                      Övertid
                    </Link>
                  )}
                  {getPermission(role, "cases:absence") !== "none" && (
                    <Link to="/absence-requests" className={`small-menu-link ${isActive("/absence-requests") ? "active" : ""}`}>
                      <FaCalendarMinus style={{ marginRight: "10px" }} />
                      Frånvaro
                    </Link>
                  )}
                </div>
              )}
            </div>
          )}

          {getPermission(role, "projects") !== "none" && (
            <div className="settings-menu">
              <button onClick={toggleProjectMenu} className="menu-link settings-menu-button">
                <div>
                  <FaFolderMinus style={{ marginRight: "10px" }} />
                  Projekt
                </div>
                <span className={`arrow ${projectMenuOpen ? "open" : ""}`}>▼</span>
              </button>
              {projectMenuOpen && (
                <div className="settings-submenu">
                  <Link to="/projects" className={`small-menu-link ${isActive("/projects") ? "active" : ""}`}>
                    <FaFolderMinus style={{ marginRight: "10px" }} />
                    Projekt
                  </Link>
                  {getPermission(role, "projects:groups") !== "none" && (
                    <Link to="/project-groups" className={`small-menu-link ${isActive("/project-groups") ? "active" : ""}`}>
                      <FaLayerGroup style={{ marginRight: "10px" }} />
                      Projektgrupper
                    </Link>
                  )}
                  {getPermission(role, "projects:overview") !== "none" && (
                    <Link to="/project-overview" className={`small-menu-link ${isActive("/project-overview") ? "active" : ""}`}>
                      <FaProjectDiagram style={{ marginRight: "10px" }} />
                      Projektöversikt
                    </Link>
                  )}
                </div>
              )}
            </div>
          )}

          {/* NY RAPPORTER-FLIK  */}
          
          {getPermission(role, "reports") !== "none" && (
            <Link to="/reports" className={`menu-link ${isActive("/reports") ? "active" : ""}`}>
              <FaFileExport style={{ marginRight: "10px" }} />
              Rapporter
            </Link>
          )}
          
         

          {getPermission(role, "notices") !== "none" && (
            <Link to="/notices" className={`menu-link ${isActive("/notices") ? "active" : ""}`}>
              <FaBullhorn style={{ marginRight: "10px" }} />
              Anslagstavla
            </Link>
          )}

          {getPermission(role, "customers") !== "none" && (
            <Link to="/customers" className={`menu-link ${isActive("/customers") ? "active" : ""}`}>
              <FaHotel style={{ marginRight: "10px" }} />
              Kunder
            </Link>
          )}
      
          {getPermission(role, "payroll") !== "none" && (
            <div className="settings-menu">
              <button onClick={togglePayrollMenu} className="menu-link settings-menu-button">
                <div>
                  <FaMoneyCheck style={{ marginRight: "10px" }} />
                  Lön
                </div>
                <span className={`arrow ${payrollMenuOpen ? "open" : ""}`}>▼</span>
              </button>
              {payrollMenuOpen && (
                <div className="settings-submenu">
                  <Link to="/payroll" className={`small-menu-link ${isActive("/payroll") ? "active" : ""}`}>
                    <FaMoneyCheckAlt style={{ marginRight: "10px" }} />
                    Lönhantering
                  </Link>
                  
                  {getPermission(role, "payroll:ob") !== "none" && (
                    <Link to="/ob-overview" className={`small-menu-link ${isActive("/ob-overview") ? "active" : ""}`}>
                      <FaCloudMoon style={{ marginRight: "10px" }} />
                      OB-översikt
                    </Link>
                  )}
                  
                  {getPermission(role, "payroll:overtime") !== "none" && (
                    <Link to="/overtime-overview" className={`small-menu-link ${isActive("/overtime-overview") ? "active" : ""}`}>
                      <FaBusinessTime style={{ marginRight: "10px" }} />
                      Övertid-översikt
                    </Link>
                  )}
                  
                  {getPermission(role, "payroll:absence") !== "none" && (
                    <Link to="/absence-overview" className={`small-menu-link ${isActive("/absence-overview") ? "active" : ""}`}>
                      <FaUserSlash style={{ marginRight: "10px" }} />
                      Frånvaro-översikt
                    </Link>
                  )}
                  
                  {getPermission(role, "payroll:export") !== "none" && (
                    <Link to="/export-payroll" className={`small-menu-link ${isActive("/export-payroll") ? "active" : ""}`}>
                      <FaFileExport style={{ marginRight: "10px" }} />
                      Exportera
                    </Link>
                  )}
                </div>
              )}
            </div>
          )}


{/*    
          {(getPermission(role, "timesmart") !== "none" || getPermission(role, "payroll") !== "none") && (
            <div className="settings-menu">
              <button onClick={toggleTimesmartMenu} className="menu-link settings-menu-button">
                <div>
                  <FaPlusCircle style={{ marginRight: "10px", color: "#4CAF50" }} />
                  TimeSmart +
                </div>
                <span className={`arrow ${timesmartMenuOpen ? "open" : ""}`}>▼</span>
              </button>
              {timesmartMenuOpen && (
                <div className="settings-submenu">
                  <Link to="/invoices" className={`small-menu-link ${isActive("/timesmart-invoice") ? "active" : ""}`}>
                    <FaFileInvoice style={{ marginRight: "10px" }} />
                    Faktura
                  </Link>
                  
                  <Link to="/timereports" className={`small-menu-link ${isActive("/timesmart-timereport") ? "active" : ""}`}>
                    <FaHistory style={{ marginRight: "10px" }} />
                    Tidstämpling
                  </Link>
                </div>
              )}
            </div>
          )} */}



          {getPermission(role, "settings") !== "none" && (
            <div className="settings-menu">
              <button onClick={toggleSettingsMenu} className="menu-link settings-menu-button">
                <div>
                  <FaWhmcs style={{ marginRight: "10px" }} />
                  Inställningar
                </div>
                <span className={`arrow ${settingsMenuOpen ? "open" : ""}`}>▼</span>
              </button>
              {settingsMenuOpen && (
                <div className="settings-submenu">

                  {getPermission(role, "settings:companySettings") !== "none" && (
                    <Link 
                      to="/company-settings" 
                      className={`small-menu-link ${isActive("/company-settings") ? "active" : ""}`}
                    >
                      <FaUsersCog style={{ marginRight: "10px" }} />
                      Företagsinställningar
                    </Link>
                  )}
                  {getPermission(role, "settings:company") !== "none" && (
                    <Link to="/business" className={`small-menu-link ${isActive("/business") ? "active" : ""}`}>
                      <MdBusiness style={{ marginRight: "10px" }} />
                      Bolagsöversikt
                    </Link>
                  )}
                  {getPermission(role, "settings:roles") !== "none" && (
                    <Link to="/role-information" className={`small-menu-link ${isActive("/role-information") ? "active" : ""}`}>
                      <FaShieldAlt style={{ marginRight: "10px" }} />
                      Roller & behörigheter
                    </Link>
                  )}

                  {historyAccess.canView && (
                    <Link to="/history" className={`small-menu-link ${isActive("/history") ? "active" : ""}`}>
                      <FaHistory style={{ marginRight: "10px" }} />
                      Historik
                    </Link>
                  )}

                  {getPermission(role, "settings:subscription") !== "none" && (
                    <Link to="/subscription" className={`small-menu-link ${isActive("/subscription") ? "active" : ""}`}>
                      <FaCreditCard style={{ marginRight: "10px" }} />
                      Prenumeration
                    </Link>
                  )}
                  <Link to="#" onClick={handleLogoutClicked} className="small-menu-link">
                    <FaWalking style={{ marginRight: "10px" }} />
                    Logga ut
                  </Link>
                </div>
              )}
            </div>
          )}

        </nav>
      </div>

      {company?.trial?.isTrial && (() => {
        const { status, days } = getTrialStatus(company.trial.trialEndsAt);

        const getText = () => {
          if (status === "expired") return "Avslutad";
          return `Avslutas om ${days} dag${days === 1 ? "" : "ar"}`;
        };

        const getIcon = () => {
          if (status === "expired") return <FaLock />;
          if (status === "urgent") return <FaBolt />;
          if (status === "warning") return <FaClock />;
          return <FaClock />;
        };

        return (
        <div
          className={`trial-card ${status}`}
          onClick={() => window.location.href = "/subscription"}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>

            {/* ICON */}
            <div style={{ fontSize: 14, opacity: 0.9 }}>
              {getIcon()}
            </div>

            {/* TEXT */}
            <div
              className="trial-card-content"
              style={{
                display: "flex",
                flexDirection: "column",
                lineHeight: 1.2,
              }}
            >
              <span
                className="trial-title"
                style={{
                  fontSize: "0.7rem",
                  opacity: 0.7,
                  marginBottom: 2,
                }}
              >
                Gratis testperiod
              </span>

              <span
                className="trial-sub"
                style={{
                  fontSize: "0.85rem",
                  fontWeight: 600,
                }}
              >
                {getText()}
              </span>
            </div>

          </div>
        </div>
        );
      })()}

      <div className="profile-card">
        <div className="profile-header" onClick={() => setProfileMenuOpen(!profileMenuOpen)}>
          <div className="profile-info">
            <FaUserCircle className="profile-avatar" />
            <div className="profile-details">
              <span className="profile-name">{user?.name || "Användare"}</span>
              <span className="profile-role">
                {ROLE_LABELS_SV[user?.role] || "Användare"}
              </span>
            </div>
          </div>
          <FaChevronDown className={`profile-arrow ${profileMenuOpen ? "open" : ""}`} />
        </div>

        {profileMenuOpen && (
          <div className="profile-menu">
            <div className="profile-company">
              <span className="company-label" style={{ paddingTop: 10 }}>Inloggad på</span>
              <span className="company-name">{company?.name || "Företag"}</span>
            </div>
            <div className="profile-email">
              <span className="email-label">E-post</span>
              <span className="email-value">{user?.email || "e-post@exempel.se"}</span>
            </div>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Nav;
